<template>
  <form action="" class="p-3">
    <div class="d-flex flex-column align-items-start pb-4">
      <label class="fw-bold pb-1" for="email" form_label>PIN</label>
      <div class="d-flex" ref="pinauth">
        <input class="form-control" type="text" pindigit maxlength="1" />
        <input class="form-control" type="text" pindigit maxlength="1" />
        <input class="form-control" type="text" pindigit maxlength="1" />
        <input class="form-control" type="text" pindigit maxlength="1" />
        <input class="form-control" type="text" pindigit maxlength="1" />
        <input class="form-control" type="text" pindigit maxlength="1" />
      </div>
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center">
      <div class="pb-1">
        <button class="btn text-white fw-bolder" loginbtn>Login</button>
      </div>
      <button class="btn" type="button" @click="showEmailLogin" loginoption>
        <small>login with email</small>
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: "PinLoginComp",
  mounted() {
    const pinauth = this.$refs.pinauth;
    const pindigits = pinauth.children;

    Array.from(pindigits).forEach((digit, index) => {
      digit.addEventListener("keydown", (event) => {
        event.preventDefault();
        if (event.code === "Backspace") {
          pindigits[index].value = "";
          if (index - 1 < 0) return;
          pindigits[index - 1].focus();
        } else if (
          [
            ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ",
            ..."abcdefghijklmnopqrstuvwxyz",
            ..."0123456789",
          ].includes(event.key)
        ) {
          pindigits[index].value = event.key;
          if (index + 1 > pindigits.length - 1) return;
          pindigits[index + 1].focus();
        }
      });
    });
  },
  methods: {
    showEmailLogin() {
      this.$store.dispatch("login/setForm", "emailform");
    },
  },
};
</script>

<style scoped>
[background] {
  background-color: var(--futurerent);
}
[form_label] {
  font-size: 14px;
}

form input {
  width: 350px;
}

[loginbtn] {
  background-color: var(--dark);
  font-size: 16px;
  padding: 8px 24px;
  outline: none;
}
[loginbtn]:hover {
  background-color: blue;
}
/* [loginbtn]:: */

[loginoption] {
  border: none;
  outline: none;
}
[loginoption] small {
  color: #0645ad;
  text-decoration: underline;
}
[pindigit] {
  aspect-ratio: 1;
  width: 45px;
  margin-inline: 10px;
  text-align: center;
  font-weight: 500;
}
[pindigit]:first-child {
  margin-left: 0px;
}
[pindigit]:last-child {
  margin-right: 0px;
}
</style>
